<template>
  <div
    class="lv-question"
    :class="{
      active: isActive.dropdown,
      shadow: disableToggle,
    }"
  >
    <div
      class="question-title__wrap"
      :class="{
        'disable-toggle' : disableToggle,
      }"
      @click="$_onToggle()"
    >
      <div class="question-title__left">
        <div class="title">
          <WsText001
            h4
            bold
            :remove-style="isRemoved"
          >
            {{ title }}
          </WsText001>
          <WsText001
            v-if="subTitle"
            h5
            light-gray
            class="mt-8"
          >
            {{ $t(subTitle) }}
          </WsText001>
        </div>
      </div>
      <div
        v-if="!disableToggle"
        class="question-title__right"
      >
        <i
          v-if="isActive.dropdown"
          class="icon-unfold-less"
        />
        <i
          v-else
          class="icon-unfold-more"
        />
      </div>
    </div>
    <slide-up-down
      :active="isActive.dropdown || disableToggle"
      :duration="500"
    >
      <div class="question-content__wrap">
        <slot name="content"/>
      </div>
    </slide-up-down>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
    subTitle: {
      type: String,
    },
    isRemoved: {
      type: Boolean,
      default: false,
    },
    disableToggle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: {
        dropdown: false,
      },
    };
  },
  methods: {
    $_onToggle() {
      if (this.disableToggle) return;
      this.isActive.dropdown = !this.isActive.dropdown;
    },
  },
};
</script>